'use strict';

module.exports = function mergeOptions(defaults, options) {
  options = options || Object.create(null);
  return [defaults, options].reduce((merged, optObj) => {
    Object.keys(optObj).forEach(key => {
      merged[key] = optObj[key];
    });
    return merged;
  }, Object.create(null));
};